import { Component, HostBinding, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { PopUpManager, WizPopUp } from '@wizeoo/akm-component-lib';

import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { BaselineFieldSettingsPop, BaselineFieldSettingsPopVO } from '../../form/pops/baseline-field-settings.pop';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { WIDGET_KIND } from '../../../../model/enums';
import { Model } from '../../../../model/model';
import { SmallFormFieldRenderer } from './smallformfield.renderer';
import { IWidget } from '../../../../manager/widgets/i-widget';

@Component({
  selector: 'tile-gridster-item',
  templateUrl:'./tile-gridster-item.component.html'
})
export class TileGridsterItem {
  @HostBinding('class') classes = 'freedata-gridster-item';
  @ViewChild('ffRenderer') ffRenderer: SmallFormFieldRenderer; // le rendu

  @Input() model: Model;
  @Input() widget: IWidget;
  @Input() tabOrder: number;

  _gridsterItem: GridsterWidgetItem; // l'objet de conf (encapsule un wcio)

  _templatingMode: boolean = false; // mode édition dans la popUp de conf

  @Input() set templatingMode(value: boolean) {
    this._templatingMode = value;
  }

  @Input() set field(value: GridsterWidgetItem) {
    this._gridsterItem = value;
    // console.log('tgic field', value);
  }

  _entity: any = null;
  @Input()public set entity(value: any) {
    this._entity = value;
    // console.log('tgic entity', value);
  }
  public get entity(): any {
    return this._entity;
  }

  @Output() delete = new EventEmitter<GridsterWidgetItem>();
  @Output() update = new EventEmitter<GridsterWidgetItem>();


  onDeleteClick() {
    this.delete.emit(this._gridsterItem);
  }

  protected fieldPop: WizPopUp; // la popUp d'édition des champs


  /** clic sur l'icone de conf */
  public onSettings(): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( BaselineFieldSettingsPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      BaselineFieldSettingsPop.baseWidth + 'px',
      BaselineFieldSettingsPop.baseHeight + 'px');

    // construction des données
    const datas: BaselineFieldSettingsPopVO = {
      model: this.model,
      item: this._gridsterItem,
      popReference:  this.fieldPop,
      popUpMode: WIDGET_KIND.TILE,
      updateCallback: this.backFromFieldPop.bind(this),
    }

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour d'édition de champ
   * 
   * @param result le nouveau code FD#lvl#field
   */
  protected backFromFieldPop(result: BaselineFieldSettingsPopVO): void {
    // console.log('back from field', this._gridsterItem);
    const fdf: FormFieldObj = this._gridsterItem.field as unknown as FormFieldObj; // TODO TODO check
    fdf.wcio = result.item.source;
    
    this.update.emit(this._gridsterItem);
    // console.log('back from field', this._gridsterItem.field);
    this.ffRenderer.feed();
  }  

}
